import { useMemo, useState } from "react";
import ContainerSimple from "../../../Components/ContainerSimple";
import { formatTradePrice } from "../../../helper/formatTradePrice";
import { ButtonLoader } from "../../../Components/AsyncState";

export default function PayoutDecisionModal({
  payoutData,
  onClose,
  onSubmit,
  submitting = false,
}) {
  const [decision, setDecision] = useState("approved");
  const [transactionId, setTransactionId] = useState("");
  const [localError, setLocalError] = useState("");

  const summaryItems = useMemo(
    () => [
      { label: "کد درخواست", value: payoutData?.code || "-" },
      {
        label: "کاربر",
        value: payoutData?.user_full_name || payoutData?.user_email || "-",
      },
      { label: "مبلغ", value: formatTradePrice(payoutData?.amount) },
      { label: "شبکه", value: payoutData?.network || "-" },
      { label: "آدرس مقصد", value: payoutData?.wallet_address || "-" },
    ],
    [payoutData],
  );

  const handleSubmit = () => {
    if (!decision) {
      setLocalError("وضعیت تصمیم را انتخاب کنید.");
      return;
    }

    setLocalError("");
    onSubmit({
      status: decision,
      transaction_id: transactionId.trim() || undefined,
    });
  };

  return (
    <ContainerSimple>
      <div className="w-full flex flex-col gap-4">
        <p className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
          تصمیم‌گیری برداشت همکاری در فروش
        </p>

        <div className="w-full rounded-xl border border-zi-border-light dark:border-zi-border-dark overflow-hidden">
          {summaryItems.map((item) => (
            <div
              key={item.label}
              className="w-full flex items-center gap-2 border-b border-zi-border-light dark:border-zi-border-dark last:border-b-0"
            >
              <div className="w-40 shrink-0 px-3 py-2 text-sm text-zi-text-light/60 dark:text-zi-text-dark/60 bg-zi-bg1-light dark:bg-zi-bg1-dark">
                {item.label}
              </div>
              <div className="px-3 py-2 text-sm text-zi-text-light dark:text-zi-text-dark break-all">
                {item.value}
              </div>
            </div>
          ))}
        </div>

        <div className="w-full flex flex-col gap-2">
          <p className="text-sm text-zi-text-light/60 dark:text-zi-text-dark/60">
            تصمیم
          </p>
          <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-2">
            <label className="rounded-lg border border-zi-border-light dark:border-zi-border-dark px-3 py-2 flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="decision"
                value="approved"
                checked={decision === "approved"}
                onChange={(event) => setDecision(event.target.value)}
              />
              <span className="text-sm text-zi-text-light dark:text-zi-text-dark">
                تایید پرداخت
              </span>
            </label>

            <label className="rounded-lg border border-zi-border-light dark:border-zi-border-dark px-3 py-2 flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="decision"
                value="rejected"
                checked={decision === "rejected"}
                onChange={(event) => setDecision(event.target.value)}
              />
              <span className="text-sm text-zi-text-light dark:text-zi-text-dark">
                رد درخواست
              </span>
            </label>
          </div>
        </div>

        <div className="w-full flex flex-col gap-2">
          <label className="text-sm text-zi-text-light/60 dark:text-zi-text-dark/60">
            شناسه تراکنش (اختیاری)
          </label>
          <input
            value={transactionId}
            onChange={(event) => setTransactionId(event.target.value)}
            placeholder="مثلا TX-123456"
            className="w-full rounded-lg py-2 px-2.5 border border-zi-border-light dark:border-zi-border-dark text-zi-text-light dark:text-zi-text-dark bg-transparent [direction:ltr]"
          />
        </div>

        {localError && <p className="text-red-500 text-sm">{localError}</p>}

        <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-2">
          <button
            type="button"
            onClick={handleSubmit}
            disabled={submitting}
            className="rounded-lg py-2 text-sm text-zi-text-dark bg-zi-gradient-button-blue disabled:opacity-60"
          >
            {submitting ? <ButtonLoader label="در حال ثبت تصمیم" /> : "ثبت تصمیم"}
          </button>

          <button
            type="button"
            onClick={onClose}
            disabled={submitting}
            className="rounded-lg py-2 text-sm border border-zi-border-light dark:border-zi-border-dark text-zi-text-light dark:text-zi-text-dark disabled:opacity-60"
          >
            انصراف
          </button>
        </div>
      </div>
    </ContainerSimple>
  );
}
